import { Injectable } from '@angular/core';
import { ApiService } from '@core/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '@env';
import { TGuid } from '@core/helpers';
import {
  IPtmSignerCertificateValidation,
  IPtmSignerCertificateValidationDTO,
  IPtmSignerQrCodeValidation,
  IPtmSignerQrCodeValidationDTO,
  PtmSignerCertificateValidationViewModelFactory,
  PtmSignerQrCodeValidationViewModelFactory,
} from '@project/view-models';

@Injectable({
  providedIn: 'root',
})
export class PtmSignerApiProviderService {
  constructor(private apiService: ApiService) {}

  validateDoctorCertificate(doctorId: TGuid): Observable<IPtmSignerCertificateValidation> {
    return this.apiService
      .get(`${environment.environmentVariables.apiCoreUrl}/PtmSigner/doctors/${doctorId}/certificate/validation`)
      .pipe(
        map((response: IPtmSignerCertificateValidationDTO) =>
          PtmSignerCertificateValidationViewModelFactory.create(response),
        ),
      );
  }

  validateDoctorQrCode(doctorId: TGuid, code: string): Observable<IPtmSignerQrCodeValidation> {
    const url = `${environment.environmentVariables.apiCoreUrl}/PtmSigner/doctors/${doctorId}/qr-code/validation`;

    return this.apiService
      .post(url, { code })
      .pipe(
        map((response: IPtmSignerQrCodeValidationDTO) => PtmSignerQrCodeValidationViewModelFactory.create(response)),
      );
  }
}
